// store/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  isLoading: false,
  user: null,
  sectionName:"dashboard",
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    login: (state) => {
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.isLoggedIn = false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setUser: (state, action) => {
  state.user = action.payload;
},
 setSectionName: (state, action) => {
  state.sectionName = action.payload;
},

  },
});

export const { login, logout, setLoading, setUser, setSectionName} = globalSlice.actions;
export default globalSlice.reducer;
